import getVarianceStyle from '../../utils/varianceStyle';

export default function varianceIndicator({ variance, trendUpward }: { variance: string; trendUpward?: string }) {
  const {
    borderColour,
    iconColour,
    textTrend,
    bgTrend,
    icon,
  } = getVarianceStyle(variance, trendUpward);

  return (
    <div className={`text-sm flex flex-row px-2 ${bgTrend} w-fit h-fit rounded-2xl border ${borderColour} justify-center items-center`}>
      {icon && <span className={iconColour}>{icon}</span>}
      <span className={`${textTrend} font-normal ml-1 pipstatus`}>{variance}</span>
    </div>
  );
}
